// match feature flags in ~/vndly/feature_flags.py
export const IS_GOOGLE_VIEWER_DISABLED = 'is_google_viewer_disabled'
export const IS_INTERVIEW_LINK_ENABLED = 'is_interview_link_enabled'
export const IS_JOB_APP_OFFER_ACCEPTED_CUSTOM_FIELDS_ENABLED = 'is_job_app_offer_accepted_custom_fields_enabled'
export const IS_IN_APP_MESSAGING_DISABLED = 'is_in_app_messaging_disabled'
export const IS_AVA_TOGGLE_ENABLED = 'is_ava_toggle_enabled'
export const IS_MOBILE_TIMESHEETS_ENABLED = 'mobile_timesheets_enabled'
export const WPM_V2 = 'wpm_v2'
export const WPM_V2_HAS_CHECKLISTS = 'wpm_v2_has_checklists'
export const CLASSIFY_CLOCKS = 'classify_clocks'
export const SHOW_US_MAPS_IN_DASHBOARD = 'show_us_maps_in_dashboard'
export const SHOW_WORLD_MAPS_IN_DASHBOARD = 'show_world_maps_in_dashboard'
export const IS_INVOICE_GROUPING_BY_COUNTRY_CODE_ENABLED = 'is_invoice_grouping_by_country_code_enabled'
export const IS_FEE_REBATE_FIELD_ENABLED = 'is_fee_rebate_field_enabled'
export const HOLIDAY_START_END_TIME = 'holiday_start_end_time'
export const SUPPLIER_PAYMENT_INTEGRATION_VALIDATIONS_NEXTSOURCE = 'supplier_payment_integration_validations_nextsource'
export const JOB_APLICATION_ACTION_ENABLED = 'job_application_action_dataset_enabled'
export const USE_WORK_TYPE_PROFILE_FOR_TIME_IMPORT = 'use_work_type_profile_for_time_import'
export const IS_PROGRAM_TEAM_ASSIGNED_TO_ONBOARDING_TASK = 'is_program_team_assigned_to_onboarding_task'
export const IS_JOBS_APPROVALS_ACTIVITY_LOG_DRAWER_ENABLED = 'is_jobs_approvals_activity_log_drawer_enabled'
export const CHARGE_CODE_STACKED_DISPLAY_SOW = 'charge_code_stacked_display_sow'
export const IS_REPLACE_INACTIVE_USERS_ENABLED = 'is_replace_inactive_users_enabled'
export const L10N_TRANSLATIONS_ENABLED = 'l10n_translations_enabled'
export const ONLY_JOB_TITLE_SELECT = 'only_job_title_select'
export const IS_BULK_UPLOAD_SOW_PAYMENTS_AND_ROLES_ENABLED = 'is_bulk_upload_sow_payments_and_roles_enabled'
export const ENABLE_PUNCH_ALLOCATION_STRATEGY = 'enable_punch_allocation_strategy'
export const ALLOW_EFFECTIVE_DATING_IN_CALC_ENGINE = 'allow_effective_dating_in_calc_engine'
export const WORKDAY_SETTINGS_RULES = 'workday_settings_rules'
export const ENABLE_EARLY_ONBOARDING_WITH_PARALLEL_PROCESSING = 'enable_early_onboarding_with_parallel_processing'
export const ADD_SPECIFIC_TRANSACTIONLOG_TYPE_FILTER_ON_GETWORKERS_REQUEST =
  'add_specific_transactionlog_type_filter_on_getworkers_request'
export const AUTO_CORRECT_OVER_ALLOCATIONS_ON_SUBMIT = 'auto_correct_over_allocations_on_submit'
export const IS_HIREDSCORE_ENABLED = 'is_hiredscore_enabled'
export const IS_HIREDSCORE_FETCH_ENABLED = 'is_hiredscore_fetch_enabled'
export const BROWN_SPECIFIED_FIELDS = 'brown_specified_fields'
export const ENABLE_TIMESHEET_RESET_API_V2 = 'timesheet_reset_api_v2'
export const ENABLE_MULTI_PROGRAM_TEAM = 'enable_multi_program_team'
export const ENABLE_MULTI_PROGRAM_TEAM_SOW = 'enable_multi_program_team_sow'
export const IS_OVERTIME_AND_DOUBLE_TIME_MARKUP_ENABLED = 'is_overtime_and_double_time_markup_enabled'
export const ENABLE_WORK_ORDER_INSIGHTS_AI = 'enable_work_order_insights_ai'
export const EXCLUDE_FEES_IN_SOW_PAYMENTS_TAXES = 'exclude_fees_in_sow_payments_taxes'
export const ENABLE_PDF_BUILDER_ENHANCEMENTS = 'enable_pdf_builder_enhancements'
export const ENABLE_SCHEDULED_RATE_ADJUSTMENTS = 'enable_scheduled_rate_adjustments'
export const ENABLE_MANUAL_MULTIPLE_RATE_CREATION = 'enable_manual_multiple_rate_creation'
export const VENDOR_RBAC = 'vendor_rbac'
export const IS_VENDOR_RECOMMENDATION_ENABLED = 'is_vendor_recommendation_enabled'
export const SANA_REBRAND_ENABLED = 'sana_rebrand_enabled' as const
export const IS_NEW_TIMESHEET_LIST_PAGE_ENABLED = 'is_new_timesheet_list_page_enabled'
export const IS_MERGED_REPORTS_UI_ENABLED = 'is_merged_reports_ui_enabled'
export const POST_OFFBOARDING_AND_CHECKLIST_GENERATION_STATUS = 'post_offboarding_and_checklist_generation_status'
export const ENABLE_MULTI_CANDIDATE_COMPARISON = 'enable_multi_candidate_comparison'
export const ENABLE_APPLICANTS_SPLIT_LIST = 'enable_applicants_split_list'
export const IS_AI_ENABLEMENT_PAGE_ENABLED = 'is_ai_enablement_page_enabled'
export const IS_VNDLY_ASSISTANT_CHAT_ENABLED = 'is_vndly_assistant_chat_enabled'
export const SOW_ADDITIONAL_PAY_TYPES = 'sow_additional_pay_types'
export const WPM_BULK_ADD_AND_APPLY = 'wpm_bulk_add_and_apply'
export const BILLING_CYCLE_RULES_BEYOND_WORK_ORDERS = 'billing_cycle_rules_beyond_work_orders'
